import { useAuth } from "react-oidc-context";


const Login = () => {
    const auth = useAuth();
    auth.signinRedirect();

    return <p>Du blir videresendt til innlogging. Vennligst vent.</p>;
}

export default Login;